module.exports = __webpack_public_path__ + "static/media/scroll.f73756e0.svg";